import styled from "styled-components/macro";

import { useHasContactUs } from "Flocknote/stateHooks";

import { useIsFeatureFlagEnabled } from "Giving/ManageMyGivingPage/useIsFeatureFlagEnabled";

import { useHelpEmail } from "../stateHooks";

export default function Footer() {
  const featureFlagEnabled = useIsFeatureFlagEnabled();
  const helpEmail = useHelpEmail();
  const [hasContactUs] = useHasContactUs();

  if (!featureFlagEnabled || hasContactUs) {
    return null;
  }

  return (
    <Wrapper>
      <div>
        Have questions, or need help? Please contact us at{" "}
        <a href={`mailto:${helpEmail}`}>{helpEmail}</a>.
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  padding: 20px;
  padding-bottom: 60px;
  padding-top: 40px;
  color: var(--textPrimary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
